import { useState } from "react";
import PassItem from "./PassItem";
import classNames from "classnames";
import { CSSTransition } from "react-transition-group";
import styles from "./DropdownButton.module.css";
import ClickAwayListener from "./ClickAwayListener";

export default function PassGrid({
  items,
  festivalId,
  displayMode = "default",
  colorPalette = "default",
  onItemClick,
  ...rest
}) {
  return (
    <div className="-m-2 flex flex-wrap">
      {items.map((item, idx) => (
        <div
          key={item.id}
          className="w-full sm:w-1/2 md:w-1/3 lg:w-1/4 xl:w-1/4 mb-4"
        >
          <PassItem
            item={item}
            festivalId={festivalId}
            colorPalette={colorPalette}
            isGrid={true}
            {...rest}
            onClick={onItemClick}
          />
        </div>
      ))}
    </div>
  );
}
